export default __webpack_public_path__ + "1.17.16/static/media/link-arrow.a76636ac.svg";